import { render } from "./LandingGlobalWarming.vue?vue&type=template&id=811b16fe&scoped=true"
import script from "./LandingGlobalWarming.vue?vue&type=script&lang=js"
export * from "./LandingGlobalWarming.vue?vue&type=script&lang=js"

import "./LandingGlobalWarming.vue?vue&type=style&index=0&id=811b16fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811b16fe"]])

export default __exports__